module.exports = ".chart-padding {\n  padding: 25px 0px 5px;\n}\n\ntable thead tr th,\ntable tbody tr td {\n  text-align: center;\n}\n"